<script>
  import * as Mousetrap from 'mousetrap';
  import * as record from '../../../node_modules/mousetrap/plugins/record/mousetrap-record';
  import { onMount } from 'svelte';
  import { a } from '../../../shared/globalState/a';
  import { create as dbCreate } from '../../../services/database';
  import { CommandList as cl } from '../../../models/CommandList';
  import { createEventDispatcher } from 'svelte';

  let dispatch = createEventDispatcher();
  const dispatchEvName = 'updateCommands';

  export let show;

  let cm = cl.cm;


  // *** bind show and hide keyset ***
  onMount(() => {
    setDefaultShortcutForKeySetOperation();
  });

  function setWidthAndHeightCss(node) {
    // *** dialog width and height
    let dialogWidth = getComputedStyle(node).width;
    let dialogHeight = getComputedStyle(node).height;
    document.documentElement.style.setProperty('--keyset-dialog-width', dialogWidth);
    document.documentElement.style.setProperty('--keyset-dialog-height', dialogHeight);
  }

  function setDialogContentMargin(node) {
    let dialogHeaderHeight = getComputedStyle(node).height;
    document.documentElement.style.setProperty('--keyset-dialog-header-height', dialogHeaderHeight);
  }

  function recordKeySet(event, commandType) {
    event.preventDefault();
    Mousetrap.record(function (sequence) {
      let seq = sequence.join(' ');
      event.target.value = seq;
      cm[commandType].preSavedShortcut = seq;
      let seqRu = getSequenceRuByEn(seq);
      cm[commandType].preSavedShortcutRu = seqRu;
    });
  }

  function saveKeySet(event) {

    for (const key in cm) {
      if (Object.prototype.hasOwnProperty.call(cm, key)) {
        const element = cm[key];
        element.shortcutEn = element.preSavedShortcut ? element.preSavedShortcut : element.shortcutEn;

        element.shortcutRu = element.preSavedShortcutRu ? element.preSavedShortcutRu : element.shortcutRu;

        element.preSavedShortcut = null;
        element.preSavedShortcutRu = null;
      }
    }
    // сохранить в базе данных

    // выполнить привязку с новыми сочетаниями клавиш
    Mousetrap.reset();
    setDefaultShortcutForKeySetOperation();

    for (const key in cm) {
      // пропустить привязку для команды keyboard
      if (['keyboard'].includes(key)) continue;
      if (Object.prototype.hasOwnProperty.call(cm, key)) {
        const element = cm[key];
        if (element.shortcutEn && element.shortcutRu) {
          Mousetrap.bind(element.shortcutEn, function (event) {
            event.preventDefault();
            element.run(event);
          });
          Mousetrap.bind(element.shortcutRu, function (event) {
            event.preventDefault();
            element.run(event);
          });

          element.prevShortcutEn = null;
          element.prevShortcutRu = null;
        }
      }
    }
    show = false;
    a.blockUI = false;

    dbCreate(cl.cmSealed());
    a.storedCommands$.next(cm);

    dispatch(dispatchEvName, cm);
  }

  function setDefaultShortcutForKeySetOperation() {
    Mousetrap.bind('ctrl+shift+k', function (e) {
      e.preventDefault();
      show = true;
      a.blockUI = true;
    });
    Mousetrap.bind('esc', function () {
      if (show) {
        show = false;
        a.blockUI = false;
      }
    });
  }

  function hideDialog() {
    show = false;
    a.blockUI = false;
  }

  function getSequenceRuByEn(sequenceEn) {
    var arrBySpace = sequenceEn.split(' ');
    let modified = arrBySpace.map((part) => {
      let arrByPlus = part.split('+');
      if (arrByPlus.length > 1) {
        let charEn = arrByPlus[arrByPlus.length - 1];
        let charRu = getRussianCharByEnglish(charEn);
        arrByPlus.pop();

        arrByPlus.push(charRu);
      } else {
        arrByPlus[0] = getRussianCharByEnglish(arrByPlus[0]);
      }
      return arrByPlus.join('+');
    });
    return modified.flat().join(' ');
  }

  function getRussianCharByEnglish(charEn) {
    var charRu = null;

    var numberPattern = /\d/g;
    if (charEn.match(numberPattern)) {
      return charEn;
    }

    switch (charEn) {
      case 'q':
        charRu = 'й';
        break;
      case 'w':
        charRu = 'ц';
        break;
      case 'e':
        charRu = 'у';
        break;
      case 'r':
        charRu = 'к';
        break;
      case 't':
        charRu = 'е';
        break;
      case 'y':
        charRu = 'н';
        break;
      case 'u':
        charRu = 'г';
        break;
      case 'i':
        charRu = 'ш';
        break;
      case 'o':
        charRu = 'щ';
        break;
      case 'p':
        charRu = 'з';
        break;
      case 'a':
        charRu = 'ф';
        break;
      case 's':
        charRu = 'ы';
        break;
      case 'd':
        charRu = 'в';
        break;
      case 'f':
        charRu = 'а';
        break;
      case 'g':
        charRu = 'п';
        break;
      case 'h':
        charRu = 'р';
        break;
      case 'j':
        charRu = 'о';
        break;
      case 'k':
        charRu = 'л';
        break;
      case 'l':
        charRu = 'д';
        break;
      case 'z':
        charRu = 'я';
        break;
      case 'x':
        charRu = 'ч';
        break;
      case 'c':
        charRu = 'с';
        break;
      case 'v':
        charRu = 'м';
        break;
      case 'b':
        charRu = 'и';
        break;
      case 'n':
        charRu = 'т';
        break;
      case 'm':
        charRu = 'ь';
        break;

      default:
        break;
    }
    return charRu;
  }

  a.storedCommands$.subscribe(async (storedCommands) => {

    

    if (Object.keys(storedCommands).length) {
      cl.updateShortcuts(storedCommands);
      assignKeyShortcuts(cl.cm);
    } else {
      assignKeyShortcuts(cl.cm);
    }

    dispatch(dispatchEvName, cm);
  });

  function assignKeyShortcuts(obj) {
    
    for (const key in obj) {
      // пропустить привязку для команды keyboard
      if (['keyboard'].includes(key)) continue;
      if (Object.prototype.hasOwnProperty.call(cl.cm, key)) {
        const element = cl.cm[key];
        if (element.shortcutEn && element.shortcutRu) {
          // английский
          Mousetrap.bind(element.shortcutEn, function (event) {
            if (a.mode === 'text') return;
            element.run(event);
          });
          // русский
          Mousetrap.bind(element.shortcutRu, function (event) {
            if (a.mode === 'text') return;
            element.run(event);
          });
        }
      }
    }
  }
</script>

{#if cm && show}
  <div class="dialog" use:setWidthAndHeightCss>
    <div class="dialog-header" use:setDialogContentMargin>
      <div>
        <button class="m-btn-accept" on:click={saveKeySet}>Сохранить</button>
        <button
          class="m-btn-cancel"
          on:click={() => {
            show = false;
            a.blockUI = false;
          }}
          >Отмена
        </button>
      </div>
      <div>
        <h1 class="text-center">Сочетания клавиш</h1>
        <small>Нажмите сочетание клавиш в полях ввода и немного подождите</small>
      </div>
      <div class="d-flex">
        <button on:click={hideDialog}>
          <svg
            class="h-6 w-6 text-slate-500"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round">
            <circle cx="12" cy="12" r="10" />
            <line x1="15" y1="9" x2="9" y2="15" />
            <line x1="9" y1="9" x2="15" y2="15" />
          </svg>
        </button>
      </div>
    </div>
    <div class="dialog-content">
      {#each Object.keys(cm) as commandType}
        <div class="grid-row mb-2">
          <div>
            {#if commandType === 'text'}
              <input
                name="shortcut"
                class="form-control font-monospace"
                placeholder="Нажмите клавиши..."
                value={cm[commandType].shortcutEn?.toLowerCase()}
                on:keydown={recordKeySet(event, commandType)}
                disabled
                style="user-select: none;" />
            {:else if commandType === 'keyboard'}
              <input
                name="shortcut"
                class="form-control font-monospace"
                placeholder="Нажмите клавиши..."
                value={cm[commandType].shortcutEn?.toLowerCase()}
                on:keydown={recordKeySet(event, commandType)}
                disabled />
            {:else}
              <input
                name="shortcut"
                class="form-control font-monospace"
                placeholder="Нажмите клавиши..."
                value={cm[commandType].shortcutEn?.toLowerCase()}
                on:keydown={recordKeySet(event, commandType)} />
            {/if}
          </div>
          <div style="align-self:center">
            <label for="">{cm[commandType].name}</label>
          </div>
        </div>
      {/each}
    </div>
  </div>
{/if}

<style>
  .dialog {
    position: absolute;
    top: calc(100vh / 2 - var(--keyset-dialog-height) / 2);
    left: calc(100vw / 2 - var(--keyset-dialog-width) / 2);
    background-color: white;
    padding: 0 2em;
    border-radius: 0.5em;
    z-index: 20;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    max-height: 500px;
    overflow: auto;
  }

  h1 {
    font-size: large;
    font-weight: bold;
    text-align: center;
  }

  input {
    font-size: 1.1em;
    /* padding: 0 0.25em;
        border-radius: 0.25em; */
  }

  .grid-row {
    display: grid;
    grid-template-columns: 1fr 2fr;
    column-gap: 0.5em;
  }

  .dialog-header {
    position: fixed;
    display: flex;
    align-content: center;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    padding: 1em 0;
    border-bottom: 1px solid var(--woodsmoke-500);
  }

  .dialog-content {
    margin-top: calc(var(--keyset-dialog-header-height) + 1em);
  }
</style>
